import { ShiftStatus, WaypointStatusName, WaypointType, WaypointActionStatusName } from '@caresend/types';
import { hasStatus } from '../dataHelpers/status.js';
import { formatTimeZoneDateSimple } from '../formatters/date.js';
import { initTimeZoneDate } from './date.js';
import { generateID } from './id.js';

const initShift = timeZone => ({
  creationTimestamp: Date.now(),
  endTime: initTimeZoneDate(timeZone),
  id: generateID(),
  startTime: initTimeZoneDate(timeZone),
  status: ShiftStatus.PENDING
});
const initWaypointContact = () => ({
  custom: false
});
/** @deprecated Can initialize empty location obj */

const initWaypoint = (type, location = {
  lat: 0,
  lng: 0
}, place) => {
  const waypoint = {
    id: generateID(),
    location,
    type,
    status: {
      status: WaypointStatusName.IN_ITINERARY,
      timestamp: Date.now()
    }
  };

  if (type === WaypointType.PATIENT) {
    waypoint.contact = initWaypointContact();
    waypoint.status.status = WaypointStatusName.CREATED;
  }

  if (place) waypoint.placeID = place.id;

  if (place === null || place === void 0 ? void 0 : place.additionalInstructions) {
    waypoint.placeInstructions = place.additionalInstructions;
  }

  return waypoint;
};
const initWaypointAction = (type, waypointID, actionDuration, procedures, waypointActionID) => {
  const id = waypointActionID !== null && waypointActionID !== void 0 ? waypointActionID : generateID();
  return Object.assign(Object.assign({
    id,
    duration: {
      actionDuration: actionDuration !== null && actionDuration !== void 0 ? actionDuration : 5
    },
    type,
    status: {
      timestamp: new Date().getTime(),
      status: WaypointActionStatusName.INCOMPLETE
    }
  }, procedures ? {
    procedures
  } : undefined), {
    waypointID
  });
};
/** Gets the date, arrival time, and departure time labels for a waypoint */

const getWaypointDateTimeLabels = (waypointStatus, waypointTransitInfo) => {
  let date;
  let arrivalTime;
  let completionTime;

  if (hasStatus(waypointStatus, WaypointStatusName.COMPLETE)) {
    date = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.completionTime;
    arrivalTime = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.arrivalTime;
    completionTime = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.completionTime;
  }

  if (hasStatus(waypointStatus, WaypointStatusName.AT_WAYPOINT)) {
    date = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.arrivalTime;
    arrivalTime = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.arrivalTime;
  }

  if (hasStatus(waypointStatus, WaypointStatusName.TRANSIT_WAYPOINT)) {
    date = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.departureTime;
    arrivalTime = waypointTransitInfo === null || waypointTransitInfo === void 0 ? void 0 : waypointTransitInfo.arrivalTime;
  }

  const dateLabel = formatTimeZoneDateSimple(date, 'MMMM D');
  const arrivalTimeLabel = arrivalTime ? formatTimeZoneDateSimple(arrivalTime, 'h:mm a') : undefined;
  const completionTimeLabel = completionTime ? formatTimeZoneDateSimple(completionTime, 'h:mm a') : undefined;
  return {
    dateLabel,
    arrivalTimeLabel,
    completionTimeLabel
  };
};

export { getWaypointDateTimeLabels, initShift, initWaypoint, initWaypointAction, initWaypointContact };
